// For Teams Context
export const DASHBOARD_CONTEXT = 'DASHBOARD';
export const SET_TEAMS = 'SET_TEAMS';
export const SET_PAGINATED_TEAMS = 'SET_PAGINATED_TEAMS';
export const SET_SEARCH = 'SET_SEARCH';
export const SET_PER_PAGE = 'SET_PER_PAGE';
export const SET_CUSTOM_PAGE = 'SET_CUSTOM_PAGE';
export const SET_FILTERS = "SET_FILTERS";
export const SET_LOADING = 'SET_LOADING';
